module.exports = __webpack_public_path__ + "img/25-skott-horisontal.54c0a8b3.jpg";